module.exports = __webpack_public_path__ + "img/hr-tree-02-e-trunk.85b4ac72.png";